import { getBreadcrumbs as d } from "./breadcrumbs.js";
import { getDescription as p } from "./description.js";
import { getIcon as b } from "./icon.js";
import { getTabs as s } from "./tabs.js";
import { getTitle as l } from "./title.js";
const h = (r, n, e) => {
  const { transformSource: a, ...m } = e, i = d(r, e), o = s(r, e), t = a?.({ ...r, breadcrumbs: i, tabs: o }, n, m) ?? {};
  return {
    id: t?.id ?? r.id,
    title: t?.title ?? l(r, e),
    description: t?.description ?? p(r, n),
    breadcrumbs: t?.breadcrumbs ?? i,
    icon: t?.icon ?? b(r),
    tabs: t?.tabs ?? o,
    url: t?.url ?? r.url,
    tag: t?.tag ?? r.tag,
    type: t?.type ?? r.type,
    shouldOpenInNewTab: t?.shouldOpenInNewTab ?? void 0,
    appendToUrl: t?.appendToUrl ?? void 0
  };
};
export {
  h as transformInkeepSource
};
